import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ShippingType } from "src/app/shared-lib/core/settings";
import { ProductSnapshot } from 'src/app/shared-lib/domains/product';
import { CartService } from '../cart.service';

@Component({
  selector: 'app-popup-before-pay',
  templateUrl: './popup-before-pay.component.html',
  styleUrls: ['./popup-before-pay.component.scss'],
  standalone: false
})
export class PopupBeforePayComponent implements OnInit {

  @Input() freeShippingAmount;
  @Input() postalCode;

  storeProductsInCart: ProductSnapshot[];

  constructor(
    private modalController: ModalController,
    public cartService: CartService,
    private navController: NavController
  ) {
  }

  ngOnInit(): void {
    this.storeProductsInCart = this.cartService.getStoreProductsInCart().map(item => item.product);
  }

  get quantityToFreeShipping() {
    return this.freeShippingAmount - this.cartService.shippingProductPrice;
  }

  onView() {
    this.closeDialog(true);
  }

  closeDialog(view = false) {
    this.modalController.dismiss({
      'view': view
    });
  }

  getShippingPrice() {
    return this.cartService.getShippingPrice(this.postalCode, this.cartService.cart, ShippingType.STANDARD).amt;
  }

  goToStore() {
    this.navController.navigateForward('/papeleria/catalogo');
  }
}

